import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'buefy/dist/buefy.css'
import './main.scss'
import './plugins'
import '@mdi/font/css/materialdesignicons.css'
import moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City')
moment.locale('es')
import './utils/vee-validate'
import './filters.js'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.prototype.$moment = moment

Vue.config.productionTip = false

//Set axios header
//import UserStorage from '@/utils/Storage/UserStorage'
//import axios from 'axios'

/*
const userStorage = UserStorage.getInstance()
const token = userStorage.getObject()?.token
const current_doctor = userStorage.getDoctor()?.id

if (token != null) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`
  if (current_doctor) axios.defaults.headers.doctorId = current_doctor ?? ''
}
*/
/* eslint-disable */
firebase.auth().onAuthStateChanged(user => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
/* eslint-enable */
